import { render, staticRenderFns } from "./Sound.vue?vue&type=template&id=584d872a&scoped=true"
import script from "./Sound.vue?vue&type=script&lang=js"
export * from "./Sound.vue?vue&type=script&lang=js"
import style0 from "./Sound.vue?vue&type=style&index=0&id=584d872a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d872a",
  null
  
)

export default component.exports